export const CONTACT = {
  name: "Sadiya",
  email: "grow@scalesolutions.in",
  phone: "+91 8700732548",
  phoneHref: "tel:+918700732548",
  whatsappHref: "https://wa.me/918700732548?text=" + encodeURIComponent("Hi Sadiya, I'd like to know more about a Discovery Session."),
  web: "www.scalesolutions.in",
  webHref: "https://www.scalesolutions.in",
};

export const NAV_LINKS = [
  { id: "about", label: "About" },
  { id: "approach", label: "Approach" },
  { id: "clients", label: "Clients" },
  { id: "services", label: "Services" },
  { id: "pricing", label: "Pricing" },
  { id: "blog", label: "Insights", route: "/blog" },
  { id: "contact", label: "Contact", route: "/contact" },
];

export const HERO_TAGS = ["Startups", "Fundraising", "Franchise", "India Market Entry"];

export const LEDGER = [
  { year: "2007", org: "MartJack.com", note: "Early employee, e-retail" },
  { year: "MGH", org: "Business leadership", note: "2,200% growth in one year" },
  { year: "OYO", org: "OYO Rooms", note: "AVP, supply & B2B growth" },
  { year: "2016", org: "Glam Studios", note: "Founder, 400+ franchisees" },
  { year: "Now", org: "Scale Solutions", note: "Coaching & consulting" },
];

export const MARQUEE = [
  "MartJack.com",
  "MGH",
  "CNBC Masterpreneur Semifinalist",
  "OYO Rooms",
  "Glam Studios",
  "IIM Calcutta",
  "National Salon Chain of the Year",
  "Times Business Award",
  "Beauty Entrepreneur of the Year",
];

export const ABOUT_PARAGRAPHS = [
  "My journey began in 2007 with MartJack.com, one of India's earliest e-retail platforms. I then spent six years in a business leadership role at MGH, helping grow the company by 2,200% in a single year and taking it to the semifinals of CNBC's Masterpreneur out of 1,800 contestants.",
  "I joined OYO Rooms as AVP, streamlining supply-side operations and B2B growth for India's largest branded stay chain — before founding Glam Studios in 2016, India's first tech-enabled chain of branded budget salons, and selling and onboarding 400+ franchisees.",
  "I hold a Senior Management Program certification in Strategy & Leadership from IIM Calcutta, and have been recognised as National Salon Chain of the Year, Times Business Award winner, and Beauty Entrepreneur of the Year.",
];

export const STATS = [
  { value: "2,200%", label: "Revenue growth achieved in one year at MGH" },
  { value: "400+", label: "Franchisees sold & onboarded at Glam Studios" },
  { value: "15+ yrs", label: "Across travel tech, hospitality & beauty retail" },
];

export const APPROACH = [
  {
    key: "coaching",
    letter: "A",
    title: "Coaching",
    lead: "For founders, solopreneurs, and leaders",
    body: "who need clarity, decision-making frameworks, and the confidence to lead through ambiguity. We work on your mindset and judgment, not just your to-do list.",
  },
  {
    key: "consulting",
    letter: "B",
    title: "Consulting",
    lead: "For businesses that need hands-on systems:",
    body: "structure, SOPs, go-to-market strategy, and execution support. We build the thing, together, and hand you something that keeps working after I leave.",
  },
];

export const STEPS = [
  { n: "Step One", title: "Discover", body: "A focused conversation to understand your goals, constraints, and the real challenge behind the ask." },
  { n: "Step Two", title: "Design", body: "Together, we build the specific framework, system, or plan your business or leadership stage actually needs." },
  { n: "Step Three", title: "Execute", body: "Hands-on support putting it into practice, so it holds up long after the engagement ends." },
];

export const CLIENTS = [
  "Everest Fleet", "Mind Your Fleet", "Stay Vista", "iGroomUp", "Hashtags.ooo",
  "Sarvananda Resorts", "Earthcon Developers", "Citara", "Fresh Bites", "Astrojata",
];

export const SERVICES = [
  { n: "01", tag: "Coaching", title: "Founder Mindset & Decision-Making", body: "Frameworks for clearer decisions, overcoming limiting beliefs, and building the confidence to lead through ambiguity." },
  { n: "02", tag: "Consulting", title: "Business Model & GTM Strategy", body: "Go-to-market strategy, business model refinement, and market positioning grounded in real operating experience." },
  { n: "03", tag: "Consulting", title: "Structuring & SOPs", body: "Turning founder-dependent chaos into documented, repeatable systems." },
  { n: "04", tag: "Consulting", title: "Fundraising & Investor Readiness", body: "Pitch decks, business plans, and funding roadmaps." },
  { n: "05", tag: "Consulting", title: "Franchise Expansion", body: "Franchise model design, franchisee acquisition, onboarding systems, and the operations playbook." },
  { n: "06", tag: "Consulting", title: "India Market Entry for International Beauty & Wellness Brands", body: "Market entry strategy, localisation, supply chain and vendor setup, SOPs, and partnership structuring." },
];

export const PRICING = [
  { offer: "Discovery Session", best: "Anyone starting out", inc: "45-min consultation to diagnose the right path", price: "₹4,999", featured: true },
  { offer: "Startup Diagnostic Sprint", best: "Early-stage founders", inc: "2–3 week audit + prioritised roadmap", price: "₹1.5–3L" },
  { offer: "Scale-Up Program", best: "Growth-stage founders", inc: "8–12 week engagement: SOPs, GTM, fundraising prep", price: "₹6–15L" },
  { offer: "Fractional Advisory", best: "Funded startups", inc: "Monthly retainer: strategy calls, board-prep, hiring support", price: "₹1–2.5L/mo" },
  { offer: "Franchise Expansion Program", best: "Brands scaling via franchising", inc: "Model design, franchisee acquisition, onboarding & ops playbook", price: "₹3–8L" },
  { offer: "India Market Entry Program", best: "International beauty/wellness brands", inc: "Entry strategy, localisation, franchise/vendor structuring", price: "Custom" },
  { offer: "Training & Workshops", best: "Teams & leadership groups", inc: "Sales training, SOP bootcamps, leadership workshops", price: "₹50K–1.5L/session" },
];
